import React, { useEffect, useState } from 'react';
import { List, Avatar, Modal, Empty, Spin } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { getAllNotifications } from '../../api/notification';
import dayjs from 'dayjs';

export default function NotificationList() {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        getAllNotifications("page=1&pageSize=10", (res) => {
            setNotifications(res?.data || []);
            setLoading(false);
        });
    }, []);

    const handleNotificationClick = (item) => {
        setSelectedNotification(item);
        setIsModalVisible(true);
    };

    return (
        <div className="w-[320px] md:w-[380px] max-h-[450px] flex flex-col">
            <div className="px-4 py-3 border-b bg-white flex justify-between items-center sticky top-0 z-10">
                <span className="font-bold text-base text-gray-800">Thông báo</span>
                <span className="text-xs text-blue-600 cursor-pointer hover:underline">Đã xem tất cả</span>
            </div>
            <div className="overflow-y-auto flex-grow custom-scrollbar">
                {loading ? (
                    <div className="flex justify-center items-center py-20">
                        <Spin size="medium" />
                    </div>
                ) : notifications.length > 0 ? (
                    <List
                        itemLayout="horizontal"
                        dataSource={notifications}
                        renderItem={(item) => (
                            <List.Item
                                className="cursor-pointer hover:bg-gray-50 px-4 border-b border-gray-100 last:border-b-0 transition-colors duration-200"
                                onClick={() => handleNotificationClick(item)}
                            >
                                <List.Item.Meta
                                    avatar={
                                        <div className="bg-yellow-100 p-2 rounded-full flex items-center justify-center">
                                            <BellOutlined className="text-yellow-500 text-base" />
                                        </div>
                                    }
                                    title={<span className="font-bold text-sm text-gray-800">{item.title}</span>}
                                    description={
                                        <div className="space-y-1">
                                            <div
                                                className="text-xs text-gray-500 line-clamp-2 leading-snug"
                                                dangerouslySetInnerHTML={{ __html: item.mess }}
                                            />
                                            <p className="text-[10px] text-gray-400 font-medium">
                                                {dayjs(item.create_at).format('DD/MM/YYYY HH:mm')}
                                            </p>
                                        </div>
                                    }
                                />
                            </List.Item>
                        )}
                    />
                ) : (
                    <div className="py-16 text-center">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Hiện tại chưa có thông báo nào" />
                    </div>
                )}
            </div>

            <div className="px-4 py-2 bg-gray-50 border-t text-center">
                <button className="text-xs font-semibold text-blue-600 hover:text-blue-800 transition-colors">
                    Xem tất cả thông báo
                </button>
            </div>

            <Modal
                title={
                    <div className="flex items-center text-gray-800">
                        <BellOutlined className="text-yellow-500 mr-2" />
                        <span className="font-bold text-lg">{selectedNotification?.title}</span>
                    </div>
                }
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                centered
                width={500}
                className="notification-modal"
            >
                <div className="py-4 border-t border-gray-100 mt-2">
                    <div
                        className="text-gray-700 text-sm leading-relaxed whitespace-pre-wrap html-content"
                        dangerouslySetInnerHTML={{ __html: selectedNotification?.mess }}
                    />
                    <div className="mt-8 flex justify-between items-center text-[11px] text-gray-400 font-medium border-t pt-4">
                        <span>Phân loại: {selectedNotification?.type || 'Hệ thống'}</span>
                        <span>Ngày nhận: {dayjs(selectedNotification?.create_at).format('DD/MM/YYYY HH:mm')}</span>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
